'use client';

import { type FieldValues, type Path, useFormContext, useWatch } from 'react-hook-form';
import { DiskSlider } from './disk-slider';
import * as m from '@paraglide/messages';
import { allTariffs } from '@/enteties/tariff/api';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { TariffSelector } from '@/enteties/tariff/ui/tariff-selector';
import FormControlWithLabel from '@/shared/ui/form-control-with-label';
import { DevTool } from '@hookform/devtools';
interface DiskSelectProps<T extends FieldValues> {
  nameSelectType: Path<T>;
  nameSelectClass: Path<T>;
  isSelectTypeDisabled?: boolean;
  isSelectClassDisabled?: boolean;
  nameSlider: Path<T>;
  nameTariffId?: Path<T>;
  onlyIncrease?: boolean;
  defaultValue?: number;
}
const resourceTypeOptions = [{
  name: m.quota_resourceType_VOLUME(),
  value: 'VOLUME'
}];
// const resourceClassOptions = [
//   { name: 'NFS', value: 'NFS_STORAGE' },
//   // { name: 'Longhorn', value: 'LONGHORN_STORAGE' },
// ];

const min = 1;
export const DiskSelect = <T extends FieldValues,>({
  nameSelectType,
  nameSelectClass,
  nameSlider,
  isSelectClassDisabled = false,
  isSelectTypeDisabled = false,
  nameTariffId = 'tariffId' as Path<T>,
  defaultValue,
  onlyIncrease
}: DiskSelectProps<T>) => {
  // TODO: maybe add 'volume' to query options when it gets patched
  const {
    data: tariffs,
    isLoading
  } = useQuery({
    ...allTariffs.getAllTariffsQueryOptions('volume')
  });
  const form = useFormContext<T>();
  const {
    control
  } = form;
  const tariffId = useWatch({
    control,
    name: nameTariffId
  });
  const volumeTariffs = useMemo(() => {
    return tariffs?.filter(tariff => tariff.serviceTypeName === 'volume') || [];
  }, [tariffs]);
  const max = useMemo(() => {
    if (!tariffId) return 50;
    const id = +tariffId;
    return volumeTariffs.find(tar => id === tar.id)?.conditions.find(condition => condition.resourceType === 'VOLUME')?.value || 50;
  }, [tariffId, volumeTariffs]);
  const sliderValue = useWatch({
    control,
    name: nameSlider
  });
  return <div className="grid gap-10 w-full" data-sentry-component="DiskSelect" data-sentry-source-file="disk-select.tsx">
      <div className="grid grid-cols-[1fr_auto] gap-4 items-start">
        <FormControlWithLabel text={m.disk_select_name()} data-sentry-element="FormControlWithLabel" data-sentry-source-file="disk-select.tsx">
          <TariffSelector name={nameTariffId} control={control} tariffsData={volumeTariffs} disabled={isSelectTypeDisabled} isLoading={isLoading} data-sentry-element="TariffSelector" data-sentry-source-file="disk-select.tsx" />
        </FormControlWithLabel>
        {/* <FormControlSelect
          name={nameSelectType}
          disabled
          control={control}
          items={resourceTypeOptions}
          label={m.quota_resourceType_label()}
         /> */}
        {/* <div className="flex items-center justify-center gap-5"> */}
        {/* <FormControlSelect
            name={nameSelectClass}
            control={control}
            items={resourceClassOptions}
            label={m.quota_resourceClass_label()}
            disabled={true || isSelectClassDisabled}
            isLoading={isLoading}
          /> */}
        <div className="flex items-center justify-center mt-[34px]">
          <p className="font-semibold text-center min-w-[60px]">
            {sliderValue}
            {m.unit_GB()}
          </p>
        </div>
        {/* </div> */}
      </div>
      <DiskSlider disabled={!tariffId} name={nameSlider} control={control} max={max} min={min} onlyIncrease={onlyIncrease} defaultValue={defaultValue} data-sentry-element="DiskSlider" data-sentry-source-file="disk-select.tsx" />
      <DevTool control={control} data-sentry-element="DevTool" data-sentry-source-file="disk-select.tsx" />
    </div>;
};